import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { fetchStudents, markAttendence } from '../../redux/action/facultyAction';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory, Link } from 'react-router-dom';

const AttendenceFaculty = () => {
    const store = useSelector((store) => store);
    const history = useHistory();
    const dispatch = useDispatch();

    const [year, setYear] = useState('');
    const [section, setSection] = useState('');
    const [semester, setSemester] = useState('');
    const [error, setError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const date = new Date();
    const today = date.getDate();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
    const thisYear = date.getFullYear();
    const time = `${thisYear}-${month}-${today.toString().padStart(2, '0')}`; // Ensure two digits
    

    const [checkedValue, setCheckedValue] = useState([]);
    const [reasons, setReasons] = useState({});

    const handleInputChange = (e, studentId) => {
        const tempCheckedValue = [...checkedValue];
    
        if (e.target.checked) {
            tempCheckedValue.push(studentId);
            setReasons((prevReasons) => ({
                ...prevReasons,
                [studentId]: 'Present',
            }));
        } else {
            const index = tempCheckedValue.indexOf(studentId);
            if (index !== -1) {
                tempCheckedValue.splice(index, 1);
            }
            setReasons((prevReasons) => ({
                ...prevReasons,
                [studentId]: 'Absent',
            }));
        }
    
        setCheckedValue(tempCheckedValue);
    };
    

    const handleReasonChange = (e, studentId) => {
        const tempReasons = { ...reasons };
        tempReasons[studentId] = e.target.value;
        setReasons(tempReasons);
    };
    useEffect(() => {
        if (store.error) {
            setError(store.error);
        }
    }, [store.error]);

    const department = store.faculty.faculty.faculty.department;

    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(false); // Clear previous loading state
        setIsLoading(true);
        dispatch(fetchStudents(department, year, section, semester))
            .finally(() => {
                setIsLoading(false);
            });
    };
    
    
    useEffect(() => {
        if (store.error || !store.faculty.fetchedStudentsHelper) {
            setIsLoading(false);
        }
    }, [store.error, store.faculty.fetchedStudentsHelper]);
    
    // Reset loading state when the parameters for fetchStudents change
    useEffect(() => {
        setIsLoading(false);
    }, [department, year, section, semester]);

    const AddendenceformHandler = (e) => {
        e.preventDefault();
    
        // Check if year, section, and semester are not empty
        if (!year || !section || !semester) {
            alert('Please fill in the year, section, and semester before submitting attendance.');
            return;
        }
    
        if (checkedValue.length > 0) {
            // Display a confirmation alert before submitting attendance
            const userConfirmed = window.confirm('Are you sure you want to submit the attendance?');
    
            if (userConfirmed) {
                setIsLoading2(false); 
                setIsLoading2(true);
                const attendanceData = checkedValue.map((studentId) => ({
                    student: studentId,
                    year,
                    department,
                    section,
                    semester,
                    date: time,
                    status: 'Present', // Set status to 'Present' for checked checkboxes
                    reasons: reasons[studentId] || '', // Set the reason for absence
                }));
    
                // Loop through all students and set status to 'Absent' for unchecked checkboxes
                store.faculty.fetchedStudents.forEach((student) => {
                    if (!checkedValue.includes(student._id)) {
                        attendanceData.push({
                            student: student._id,
                            year,
                            department,
                            section,
                            semester,
                            date: time,
                            status: 'Absent',
                            reasons: reasons[student._id] || '',
                        });
                    }
                });
    
                dispatch(markAttendence(attendanceData)).then(() => {
                    setCheckedValue([]);
                    setIsLoading2(false);
                });
            } else {
                // User cancelled the submission
                setIsLoading2(false);
            }
        } else {
            console.error('No students selected for attendance');
            setIsLoading2(false);
        }
    };
    
    
    
    
    useEffect(() => {
        if (store.faculty.fetchedStudentsHelper) {
            setIsLoading2(false);
        }
    }, [store.faculty.fetchedStudentsHelper]);

    return (
        <div>
            {store.faculty.isAuthenticated ? (
                <>
                    <div className="container-fluid p-0">
                        <div className="d-flex">
                            <div className="print-helper">
                                <FacultyHomeHelper />
                            </div>
                            <div className="mx-1 w-100 ">
                                <div className="px-3 py-1 bg-light d-flex align-items-center justify-content-between">
                                    <h5>
                                        <Link to="/attendenceFaculty" className="text-light">
                                            <img src="/image/Back.svg" className="p-2" alt="" />
                                        </Link>
                                    </h5>
                                    <h3>
                                        <img src="/logo192.png" width={'50px'} alt="" /> Mark Attendance
                                    </h3>
                                    <button
                                        onClick={() => window.print()}
                                        type="button"
                                        className=" btn-success btn text-light"
                                    >
                                        <img src="/image/print.svg" alt="" /> Download
                                    </button>
                                </div>
                                <div className="col d-md-flex align-items-center justify-content-between ">
                                    <form
                                        className="d-md-flex align-items-center justify-content-start"
                                        noValidate
                                        onSubmit={formHandler}
                                    >
                                          <div className="form-group mx-2 print-helper">
                                        <label htmlFor="semesterId">Date</label> <br />
                                            <h5>{time}</h5>
                                        {error.semester && (
                                            <div className="invalid-feedback">{error.semester}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="yearId">Year</label>
                                        <select
                                            onChange={(e) => setYear(e.target.value)}
                                            className={classnames('form-control', {
                                                'is-invalid': error.year
                                            })}
                                            id="yearId"
                                        >
                                            <option>Select</option>
                                            <option value="I">1</option>
                                            <option value="II">2</option>
                                            <option value="III">3</option>
                                            <option value="IV">4</option>
                                        </select>
                                        {error.year && (
                                            <div className="invalid-feedback">{error.year}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="sectionId">Section</label>
                                        <select
                                            onChange={(e) => {
                                                setSection(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="sectionId"
                                        >
                                            <option>Select</option>
                                            <option value="A">A</option>
                                            <option value="B">B</option>
                                            <option value="C">C</option>
                                            <option value="D">D</option>
                                        </select>
                                        {error.section && (
                                            <div className="invalid-feedback">{error.section}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="semesterId">Semester</label>
                                        <select
                                            onChange={(e) => {
                                                setSemester(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="semesterId"
                                        >
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>
                                        {error.semester && (
                                            <div className="invalid-feedback">{error.semester}</div>
                                        )}
                                    </div>
                                    
                                    <div className="mt-3 position-relative">
                                        {!isLoading && (
                                            <button
                                                type="submit"
                                                className="btn btn-info btn-block print-helper"
                                            >
                                                <img
                                                    src="/image/search.svg"
                                                    className="mb-1"
                                                    alt=""
                                                />{' '}
                                                Search
                                                <span className="badge badge-warning position-absolute top-0 end-0">
                                                    {store.faculty.fetchedStudents.length}
                                                </span>
                                            </button>
                                        )}
                                        {isLoading && (
                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )}
                                    </div>
                                    </form>
                                </div>
                                <div className="row justify-content-center m-0">
                                    <div className="col">
                                        <div>
                                        <form onSubmit={AddendenceformHandler}>
                                    <table className="table table-bordered table-striped">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th scope="col">S.NO</th>
                                                <th scope="col">Registration Number</th>
                                                <th scope="col">Student Name</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {store.faculty.fetchedStudents.map((obj, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{obj.registrationNumber}</td>
                                                    <td>{obj.name}</td>
                                                    <td>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-control"
                                                                type="checkbox"
                                                                checked={checkedValue.includes(obj._id)}
                                                                onChange={(e) => handleInputChange(e, obj._id)}
                                                                id={`checkbox-${index}`}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {/* Only render the textarea if the checkbox is unchecked */}
                                                        {!checkedValue.includes(obj._id) && (
                                                            <textarea
                                                                value={reasons[obj._id] || ''}
                                                                onChange={(e) => handleReasonChange(e, obj._id)}
                                                                placeholder="Reason for absence"
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                    <div className="m-3 ">
                                        {!isLoading2 && (
                                            <button
                                                type="submit"
                                                className="btn btn-info btn-block print-helper "
                                            >
                                                <img
                                                    src="/image/search.svg"
                                                    className="mb-1"
                                                    alt=""
                                                />{' '}
                                                Submit
                                            </button>
                                        )}
                                        {isLoading2 && (
                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )}
                                    </div>
                                        </tbody>
                                    </table>
                                </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                history.push('/')
            )}
        </div>
    );
};

export default AttendenceFaculty;